import styled from 'styled-components';

export const Center = styled.div`
  display: flex;
  justify-content: center;
`;
